(function () {
  const REMAINING_KEYS = ["credits", "remaining", "remaining_spins", "spins_remaining", "remaining_count", "chances", "available_spins", "spin_count"];

  function readRemaining(body) {
    if (!body || typeof body !== "object") return null;
    const sources = [body, body.data];
    for (let s = 0; s < sources.length; s += 1) {
      const source = sources[s];
      if (!source || typeof source !== "object") continue;
      for (let i = 0; i < REMAINING_KEYS.length; i += 1) {
        const value = source[REMAINING_KEYS[i]];
        if (value === undefined || value === null || value === "") continue;
        const number = Number(value);
        if (Number.isFinite(number)) return number;
      }
    }
    return null;
  }

  function readField(body, key) {
    if (!body || typeof body !== "object") return undefined;
    if (body[key] !== undefined) return body[key];
    const nested = [body.data, body.result, body.eligibility];
    for (let i = 0; i < nested.length; i += 1) {
      if (nested[i] && typeof nested[i] === "object" && nested[i][key] !== undefined) return nested[i][key];
    }
    return undefined;
  }

  function landingDelta(fromDeg, index, count, extraTurns) {
    const slice = 360 / count;
    const desired = ((360 - index * slice) % 360 + 360) % 360;
    const fromNorm = ((fromDeg % 360) + 360) % 360;
    let delta = desired - fromNorm;
    if (delta < 0) delta += 360;
    return delta + 360 * extraTurns;
  }

  function polar(cx, cy, radius, deg) {
    const rad = (deg * Math.PI) / 180;
    return [cx + radius * Math.cos(rad), cy + radius * Math.sin(rad)];
  }

  function sectorPath(index, count) {
    const cx = 100;
    const cy = 100;
    const radius = 100;
    if (count <= 1) {
      return "M 100 100 m -100 0 a 100 100 0 1 1 200 0 a 100 100 0 1 1 -200 0";
    }
    const slice = 360 / count;
    const start = -90 + index * slice - slice / 2;
    const end = start + slice;
    const [x1, y1] = polar(cx, cy, radius, start);
    const [x2, y2] = polar(cx, cy, radius, end);
    const large = slice > 180 ? 1 : 0;
    return "M " + cx + " " + cy + " L " + x1 + " " + y1 + " A " + radius + " " + radius + " 0 " + large + " 1 " + x2 + " " + y2 + " Z";
  }

  function ink(hex) {
    const value = String(hex || "").replace("#", "");
    if (value.length < 6) return "#f9fafb";
    const red = parseInt(value.slice(0, 2), 16);
    const green = parseInt(value.slice(2, 4), 16);
    const blue = parseInt(value.slice(4, 6), 16);
    const luma = (red * 299 + green * 587 + blue * 114) / 1000;
    return luma > 160 ? "#29282b" : "#f9fafb";
  }

  function prizeWon(noWin, rewardEnabled) {
    return noWin !== "true" && rewardEnabled !== "false";
  }

  // ponytail: reward_enabled=false is the confetti switch and stays off. A code still overrides
  // a mis-flagged no_win when confetti is left on. openResult shows the code either way.
  function resultWon(noWin, rewardEnabled, code) {
    if (rewardEnabled === "false") return false;
    return noWin !== "true" || Boolean(code);
  }

  // null reported: server omitted a count, undo this spin's optimistic decrement.
  // null return: a newer spin owns the badge. Ceiling: a deducted spin whose body omitted
  // credits is restored until the next eligibility read that includes a count.
  function restoreCount(token, epoch, before, reported) {
    if (token !== epoch) return null;
    return reported === null ? before : reported;
  }

  var SHARE_WAIT_MS = 10000;

  // ponytail: Discord COOP makes window.closed true while the tab is still open, so a closed
  // community tab cannot cancel the claim. Closing this dialog is the only cancel. Upgrade
  // path: a same-origin bounce page that posts back when the visitor leaves.
  function shareDelayDone(elapsed, dialogHidden) {
    if (dialogHidden) return "cancel";
    if (elapsed < SHARE_WAIT_MS) return "wait";
    return "claim";
  }

  function readCode(body) {
    const keys = ["discount_code", "coupon_code"];
    for (let i = 0; i < keys.length; i += 1) {
      const value = readField(body, keys[i]);
      if (typeof value === "string" && value.trim()) return value.trim();
    }
    return "";
  }

  function findDuplicatePrizeId(ids) {
    const seen = new Set();
    for (let i = 0; i < ids.length; i += 1) {
      if (!ids[i]) continue;
      if (seen.has(ids[i])) return ids[i];
      seen.add(ids[i]);
    }
    return null;
  }

  function selfCheck() {
    if (landingDelta(0, 0, 8, 2) !== 720) throw new Error("lucky-draw: top sector");
    if (landingDelta(0, 1, 8, 2) !== 1035) throw new Error("lucky-draw: second sector");
    if (landingDelta(10, 0, 8, 2) !== 1070) throw new Error("lucky-draw: cruise align");
    if (sectorPath(0, 8).indexOf("A") === -1) throw new Error("lucky-draw: path");
    if (sectorPath(0, 1).indexOf("a") === -1) throw new Error("lucky-draw: circle");
    if (ink("#f0e3c9") !== "#29282b") throw new Error("lucky-draw: light ink");
    if (ink("#29282b") !== "#f9fafb") throw new Error("lucky-draw: dark ink");
    if (readRemaining({ credits: 2 }) !== 2) throw new Error("lucky-draw: credits");
    if (readRemaining({ data: { remaining_spins: "2" } }) !== 2) throw new Error("lucky-draw: remaining");
    const sample = { can_spin: false, credits: 0, rules: { daily_login: { available: true }, share: { available: true } } };
    if (spinsUsedUp(sample)) throw new Error("lucky-draw: claims still open");
    if (!spinsUsedUp({ can_spin: false, credits: 0, rules: { daily_login: { available: false }, share: { available: false } } })) throw new Error("lucky-draw: used up");
    if (readCode({ discount_code: " SAVE10 " }) !== "SAVE10") throw new Error("lucky-draw: discount code");
    if (readCode({ data: { coupon_code: "A" } }) !== "A") throw new Error("lucky-draw: nested code");
    if (readCode({ code: "OK" }) !== "") throw new Error("lucky-draw: status code");
    if (prizeWon("true", "true")) throw new Error("lucky-draw: marked lose");
    if (prizeWon("false", "false")) throw new Error("lucky-draw: legacy lose");
    if (prizeWon("false", "true") !== true) throw new Error("lucky-draw: win");
    if (allowSpin({ credits: 0, can_spin: true })) throw new Error("lucky-draw: zero credits");
    if (!allowSpin({ credits: 1, can_spin: false })) throw new Error("lucky-draw: has credits");
    if (allowSpin({ can_spin: true })) throw new Error("lucky-draw: missing credits");
    if (!spinsUsedUp({ can_spin: true, credits: 0, rules: { daily_login: { available: false }, share: { available: false } } })) throw new Error("lucky-draw: zero still used up");
    if (!spinsUsedUp({ can_spin: true, rules: { daily_login: { available: false }, share: { available: false } } })) throw new Error("lucky-draw: missing credits used up");
    if (spinsUsedUp({ can_spin: true, rules: { share: { available: true } } })) throw new Error("lucky-draw: missing credits share open");
    if (!sharePrompt({ credits: 0, can_spin: false, rules: { share: { available: true } } })) throw new Error("lucky-draw: share prompt");
    if (sharePrompt({ credits: 1, rules: { share: { available: true } } })) throw new Error("lucky-draw: share while credits remain");
    if (sharePrompt({ credits: 0, rules: { share: { available: false } } })) throw new Error("lucky-draw: share already used");
    if (resultWon("true", "true", "SAVE10") !== true) throw new Error("lucky-draw: code overrides no-win flag");
    if (resultWon("false", "false", "SAVE10") !== false) throw new Error("lucky-draw: confetti stays off with code");
    if (resultWon("true", "false", "SAVE10") !== false) throw new Error("lucky-draw: no-win plus confetti off");
    if (resultWon("false", "true", "") !== true) throw new Error("lucky-draw: plain win still wins");
    if (resultWon("true", "false", "") !== false) throw new Error("lucky-draw: no-win stays lose without code");
    if (restoreCount(1, 1, 2, null) !== 2) throw new Error("lucky-draw: restore omitted count");
    if (restoreCount(1, 2, 2, null) !== null) throw new Error("lucky-draw: stale spin leaves badge");
    if (restoreCount(1, 1, 2, 0) !== 0) throw new Error("lucky-draw: server count wins");
    if (shareDelayDone(SHARE_WAIT_MS - 1, false) !== "wait") throw new Error("lucky-draw: share wait");
    if (shareDelayDone(SHARE_WAIT_MS, false) !== "claim") throw new Error("lucky-draw: share claim");
    if (shareDelayDone(SHARE_WAIT_MS, true) !== "cancel") throw new Error("lucky-draw: share dialog closed");
    if (shareDelayDone(0, true) !== "cancel") throw new Error("lucky-draw: share dialog closed early");
    if (findDuplicatePrizeId(["a", "b", "a"]) !== "a") throw new Error("lucky-draw: duplicate prize id detection");
    if (findDuplicatePrizeId(["", "", "b"]) !== null) throw new Error("lucky-draw: blank prize id ignored");
  }

  function claimStillOpen(body) {
    const rules = body && body.rules;
    if (!rules) return false;
    return Boolean(rules.daily_login && rules.daily_login.available) || Boolean(rules.share && rules.share.available);
  }

  function spinsUsedUp(body) {
    if (!body) return false;
    if (readRemaining(body) > 0) return false;
    return !claimStillOpen(body);
  }

  function allowSpin(body) {
    return readRemaining(body) > 0;
  }

  function sharePrompt(body) {
    if (!body || allowSpin(body)) return false;
    const share = body.rules && body.rules.share;
    return Boolean(share && share.available === true);
  }

  function requestId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (char) {
      const rand = (Math.random() * 16) | 0;
      const next = char === "x" ? rand : (rand & 0x3) | 0x8;
      return next.toString(16);
    });
  }

  function init(root) {
    if (!root || root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    const wheel = root.querySelector("[data-wheel]");
    const sectors = root.querySelector("[data-sectors]");
    const spinButton = root.querySelector("[data-spin]");
    const remainingNode = root.querySelector("[data-remaining]");
    const statusNode = root.querySelector("[data-status]");
    const resultDialog = root.querySelector("[data-result]");
    const resultHeading = root.querySelector("[data-result-heading]");
    const resultText = root.querySelector("[data-result-text]");
    const resultCodeRow = root.querySelector("[data-result-code-row]");
    const resultCode = root.querySelector("[data-result-code]");
    const resultCopy = root.querySelector("[data-copy-code]");
    const resultOk = root.querySelector("[data-result-ok]");
    const labels = Array.from(root.querySelectorAll("[data-prize]"));
    const activityId = root.dataset.activityId || "";
    const modalId = root.dataset.modalId || "";
    const spinsTemplate = root.dataset.spinsTemplate || "{count} LEFT";
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const loggedIn = root.dataset.customer === "true";
    const email = root.dataset.email || "";
    const usedUp = root.querySelector("[data-used-up]");
    const shareDialog = root.querySelector("[data-share]");
    const shareGo = root.querySelector("[data-share-go]");
    const state = { remaining: 0, rotation: 0, spinning: false, revealed: false, eligibility: null, spinEpoch: 0, sharing: false };
    let prepared = null;

    const duplicatePrizeId = findDuplicatePrizeId(labels.map(function (label) { return label.dataset.prizeId || ""; }));
    if (duplicatePrizeId) console.warn("[lucky-draw] duplicate prize_id configured on wheel: " + duplicatePrizeId);

    labels.forEach(function (label, index) {
      const count = labels.length || 1;
      label.style.setProperty("--label-angle", index * (360 / count) + "deg");
      label.style.color = ink(label.dataset.color);
    });
    if (wheel) wheel.style.setProperty("--prize-count", String(labels.length || 1));

    if (sectors) {
      sectors.textContent = "";
      labels.forEach(function (label, index) {
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", sectorPath(index, labels.length || 1));
        path.setAttribute("fill", label.dataset.color || "#29282b");
        sectors.appendChild(path);
      });
    }

    function setStatus(message) {
      if (!statusNode) return;
      if (!message) {
        statusNode.hidden = true;
        statusNode.textContent = "";
        return;
      }
      statusNode.hidden = false;
      statusNode.textContent = message;
    }

    function setRemaining(count) {
      state.remaining = Math.max(0, count);
      if (remainingNode) remainingNode.textContent = spinsTemplate.replaceAll("{count}", String(state.remaining));
      syncSpinButton();
    }

    function syncSpinButton() {
      if (spinButton) spinButton.disabled = state.spinning;
    }

    function openUsedUp() {
      if (usedUp) usedUp.hidden = false;
    }

    function openShare() {
      if (shareDialog) shareDialog.hidden = false;
    }

    function closeShare() {
      if (shareDialog) shareDialog.hidden = true;
    }

    function celebrate() {
      if (reduceMotion || typeof window.confetti !== "function") return;
      const end = Date.now() + 2000;
      (function frame() {
        window.confetti({ particleCount: 7, angle: 60, spread: 55, origin: { x: 0 }, zIndex: 90 });
        window.confetti({ particleCount: 7, angle: 120, spread: 55, origin: { x: 1 }, zIndex: 90 });
        if (Date.now() < end) window.requestAnimationFrame(frame);
      })();
    }

    function closeResult() {
      if (resultDialog) resultDialog.hidden = true;
    }

    function openResult(title, copy, options) {
      if (!resultDialog) return;
      const code = options && options.code ? options.code : "";
      const won = Boolean(options && options.won);
      if (resultHeading) {
        resultHeading.textContent = title || "";
        resultHeading.hidden = !title;
      }
      if (resultText) {
        resultText.textContent = copy || "";
        resultText.hidden = !copy;
      }
      if (resultCodeRow) resultCodeRow.hidden = !code;
      if (resultCode) resultCode.textContent = code;
      if (resultCopy) resultCopy.textContent = "Copy";
      if (resultOk) resultOk.hidden = Boolean(code);
      resultDialog.hidden = false;
      const focusTarget = code ? resultCopy : resultOk;
      if (focusTarget) focusTarget.focus();
      if (won) celebrate();
    }

    function openLogin() {
      const opener = window["openVipLoginModal_" + modalId];
      if (typeof opener === "function") opener();
    }

    function messageFrom(body) {
      const value = readField(body, "message") || readField(body, "error");
      return typeof value === "string" && value ? value : root.dataset.errorMessage || "Something went wrong. Please try again.";
    }

    async function readJson(response) {
      const body = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(messageFrom(body));
      return body;
    }

    async function refreshEligibility(apply) {
      const params = new URLSearchParams({ activity_id: activityId });
      if (email) params.set("email", email);
      const response = await fetch("/apps/ulanzi-upload/discounts/eligibility?" + params.toString(), {
        credentials: "same-origin",
      });
      const body = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(messageFrom(body));
      if (apply !== false) {
        const remaining = readRemaining(body);
        if (remaining !== null) setRemaining(remaining);
        state.eligibility = body;
      }
      return body;
    }

    function ruleAvailable(source) {
      const rules = state.eligibility && state.eligibility.rules;
      return Boolean(rules && rules[source] && rules[source].available);
    }

    async function claimSource(source) {
      const response = await fetch("/apps/ulanzi-upload/discounts/claim", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ activity_id: activityId, source: source }),
      });
      const body = await readJson(response);
      const credits = readRemaining(body);
      if (credits !== null) setRemaining(credits);
      return body;
    }

    function prepareCredits() {
      if (!loggedIn) return Promise.resolve(null);
      if (!prepared) {
        prepared = refreshEligibility().then(function (eligibility) {
          const daily = eligibility.rules && eligibility.rules.daily_login;
          if (!daily || !daily.available) return eligibility;
          return claimSource("daily_login").then(function (claimed) {
            if (claimed && claimed.granted === true) return refreshEligibility();
            return eligibility;
          });
        }).catch(function (error) {
          prepared = null;
          throw error;
        });
      }
      return prepared;
    }

    function finishSpin(label, code) {
      const won = resultWon(label.dataset.noWin, label.dataset.rewardEnabled, code);
      openResult(label.dataset.resultTitle || label.textContent, label.dataset.resultCopy || "", {
        won: won,
        code: code || "",
      });
    }

    function copyCode() {
      const code = resultCode ? resultCode.textContent.trim() : "";
      if (!code || !resultCopy) return;
      const legacy = writeCode(code);
      const finish = function (ok) {
        if (!ok) return;
        resultCopy.textContent = "Copied!";
        window.setTimeout(function () {
          if (resultCopy.textContent === "Copied!") resultCopy.textContent = "Copy";
        }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () { finish(true); }).catch(function () { finish(legacy); });
        return;
      }
      finish(legacy);
    }

    function writeCode(code) {
      const input = document.createElement("textarea");
      input.value = code;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.top = "0";
      input.style.left = "0";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.focus();
      input.select();
      input.setSelectionRange(0, code.length);
      let ok = false;
      try { ok = document.execCommand("copy"); } catch (error) { ok = false; }
      document.body.removeChild(input);
      return ok;
    }

    function wheelTransform(deg) {
      return "rotate(" + deg + "deg)";
    }

    function paintWheel(deg) {
      if (wheel) wheel.style.transform = wheelTransform(deg);
    }

    function delay(ms) {
      return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
    }

    function beginCruise(origin) {
      if (!wheel || reduceMotion || typeof wheel.animate !== "function") return null;
      return wheel.animate(
        [{ transform: wheelTransform(origin) }, { transform: wheelTransform(origin + 360) }],
        { duration: 480, iterations: Infinity, easing: "linear" }
      );
    }

    function cruiseAngle(animation, origin) {
      if (!animation || !animation.effect || typeof animation.effect.getComputedTiming !== "function") return origin;
      const duration = animation.effect.getComputedTiming().duration;
      const time = Number(animation.currentTime) || 0;
      if (!duration || !Number.isFinite(duration)) return origin;
      return origin + ((time % duration) / duration) * 360;
    }

    function releaseCruise(animation, origin) {
      if (!animation) return origin;
      const live = cruiseAngle(animation, origin);
      paintWheel(live);
      animation.cancel();
      return live;
    }

    async function glide(from, to, duration) {
      if (!wheel || reduceMotion || typeof wheel.animate !== "function") {
        paintWheel(to);
        return;
      }
      const animation = wheel.animate(
        [{ transform: wheelTransform(from) }, { transform: wheelTransform(to) }],
        { duration: duration, easing: "cubic-bezier(.12,.72,.08,1)", fill: "forwards" }
      );
      await animation.finished.then(function () {
        paintWheel(to);
        animation.cancel();
      }).catch(function () {
        paintWheel(to);
      });
    }

    async function spin() {
      if (state.spinning) return;
      if (!loggedIn) {
        openLogin();
        return;
      }
      state.spinning = true;
      if (spinButton) spinButton.disabled = true;
      let eligibility = null;
      try {
        await prepareCredits();
        eligibility = await refreshEligibility();
      } catch (error) {
        setStatus(error && error.message ? error.message : root.dataset.errorMessage);
        state.spinning = false;
        syncSpinButton();
        return;
      }
      if (!allowSpin(eligibility)) {
        if (sharePrompt(eligibility)) openShare();
        else if (spinsUsedUp(eligibility)) openUsedUp();
        else setStatus(root.dataset.errorMessage || "");
        state.spinning = false;
        syncSpinButton();
        return;
      }
      if (!labels.length) {
        state.spinning = false;
        syncSpinButton();
        return;
      }

      const origin = state.rotation;
      const started = performance.now();
      let cruise = beginCruise(origin);
      let settled = false;
      state.spinEpoch += 1;
      const token = state.spinEpoch;
      const before = state.remaining;
      setStatus("");
      if (before > 0) setRemaining(before - 1);

      function applyCount(reported) {
        const next = restoreCount(token, state.spinEpoch, before, reported);
        if (next !== null) setRemaining(next);
      }

      function resyncCount() {
        refreshEligibility(false).then(function (body) {
          if (token !== state.spinEpoch) return;
          state.eligibility = body;
          applyCount(readRemaining(body));
        }).catch(function () {
          applyCount(null);
        });
      }

      function takeLive() {
        const animation = cruise;
        cruise = null;
        return releaseCruise(animation, origin);
      }

      try {
        const response = await fetch("/apps/ulanzi-upload/discounts/spin", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ activity_id: activityId, request_id: requestId() }),
        });
        const body = await readJson(response);
        if (!reduceMotion) {
          const waited = performance.now() - started;
          if (waited < 900) await delay(900 - waited);
        }
        const prizeId = String(readField(body, "prize_id") ?? "");
        const index = labels.findIndex(function (label) { return String(label.dataset.prizeId || "") === prizeId; });
        const nextRemaining = readRemaining(body);
        state.revealed = true;
        const live = takeLive();

        if (index < 0) {
          await glide(live, origin, 400);
          state.rotation = origin;
          // ponytail: prize_id isn't on the wheel (merchant mapping gap), but if the backend
          // still issued a real code, surface it instead of silently losing a granted reward.
          const unmappedCode = readCode(body);
          openResult("", root.dataset.unmappedMessage || "", { won: Boolean(unmappedCode), code: unmappedCode });
        } else {
          const end = live + landingDelta(live, index, labels.length, 2);
          await glide(live, end, 2200);
          state.rotation = end;
          finishSpin(labels[index], readCode(body));
        }
        settled = true;
        if (nextRemaining === null) resyncCount();
        else applyCount(nextRemaining);
      } catch (error) {
        if (!settled) {
          const live = takeLive();
          await glide(live, origin, 400);
          state.rotation = origin;
        }
        setStatus(error && error.message ? error.message : root.dataset.errorMessage);
        resyncCount();
      } finally {
        state.spinning = false;
        syncSpinButton();
      }
    }

    async function claim(source, button) {
      if (!loggedIn) {
        openLogin();
        return;
      }
      try {
        await prepareCredits();
      } catch (error) {
        setStatus(error && error.message ? error.message : root.dataset.errorMessage);
        return;
      }
      if (!ruleAvailable(source)) return;
      if (button) button.disabled = true;
      setStatus("");
      try {
        const claimed = await claimSource(source);
        if (claimed && claimed.granted === true) {
          await refreshEligibility();
          setStatus(root.dataset.claimSuccess || "");
        }
      } catch (error) {
        setStatus(error && error.message ? error.message : root.dataset.errorMessage);
      } finally {
        if (button) button.disabled = false;
      }
    }

    spinButton?.addEventListener("click", spin);

    resultCopy?.addEventListener("click", copyCode);
    root.querySelectorAll("[data-result-close]").forEach(function (button) {
      button.addEventListener("click", closeResult);
    });
    resultDialog?.addEventListener("click", function (event) {
      if (event.target === resultDialog) closeResult();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (resultDialog && !resultDialog.hidden) closeResult();
      if (shareDialog && !shareDialog.hidden) closeShare();
    });
    async function askShare() {
      if (!loggedIn) {
        openLogin();
        return;
      }
      try {
        await prepareCredits();
        await refreshEligibility();
      } catch (error) {
        setStatus(error && error.message ? error.message : root.dataset.errorMessage);
        return;
      }
      if (ruleAvailable("share")) openShare();
      else if (allowSpin(state.eligibility)) setStatus(root.dataset.shareUsed || "Share spin already claimed.");
      else openUsedUp();
    }

    function waitShare() {
      return new Promise(function (resolve) {
        const started = Date.now();
        // ponytail: poll the dialog; claim lands up to 200ms late.
        const timer = window.setInterval(function () {
          const elapsed = Date.now() - started;
          const decision = shareDelayDone(elapsed, Boolean(shareDialog && shareDialog.hidden));
          if (decision === "wait") return;
          window.clearInterval(timer);
          resolve(decision === "claim");
        }, 200);
      });
    }

    async function followShare() {
      if (state.sharing) return;
      state.sharing = true;
      if (shareGo) shareGo.disabled = true;
      const link = root.dataset.shareLink || "";
      let tab = null;
      let opened = false;
      try {
        tab = link ? window.open("", "_blank") : null;
        if (tab) {
          try { tab.opener = null; } catch (error) { /* ponytail: opener may already be severed */ }
        }
        if (link && !tab) {
          closeShare();
          setStatus(root.dataset.shareBlocked || "Allow pop-ups to open the community, then try again.");
          return;
        }
        if (tab && link) {
          try { tab.location.href = link; } catch (error) { /* ponytail: blank tab already severed */ }
        }
        await refreshEligibility();
        if (!ruleAvailable("share")) {
          if (tab) tab.close();
          closeShare();
          if (allowSpin(state.eligibility)) setStatus(root.dataset.shareUsed || "Share spin already claimed.");
          else openUsedUp();
          return;
        }
        opened = true;
        const ready = await waitShare();
        if (!ready) return;
        await refreshEligibility();
        if (!ruleAvailable("share")) {
          closeShare();
          if (allowSpin(state.eligibility)) setStatus(root.dataset.shareUsed || "Share spin already claimed.");
          else openUsedUp();
          return;
        }
        const claimed = await claimSource("share");
        if (!(claimed && claimed.granted === true)) {
          setStatus(root.dataset.errorMessage || "");
          return;
        }
        setStatus(root.dataset.claimSuccess || "");
        closeShare();
        try { await refreshEligibility(); } catch (error) { /* ponytail: grant already stuck; badge catches up on the next read */ }
      } catch (error) {
        if (tab && !opened) tab.close();
        setStatus(error && error.message ? error.message : root.dataset.errorMessage);
      } finally {
        state.sharing = false;
        if (shareGo) shareGo.disabled = false;
      }
    }

    root.querySelectorAll("[data-claim]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (button.dataset.claim === "share") askShare();
        else claim(button.dataset.claim, button);
      });
    });
    shareGo?.addEventListener("click", followShare);
    root.querySelectorAll("[data-share-close]").forEach(function (button) {
      button.addEventListener("click", closeShare);
    });
    shareDialog?.addEventListener("click", function (event) {
      if (event.target === shareDialog) closeShare();
    });

    if (spinButton) spinButton.disabled = false;
    root.querySelector("[data-used-up-close]")?.addEventListener("click", function () {
      if (usedUp) usedUp.hidden = true;
    });
    if (loggedIn) {
      prepareCredits().catch(function (error) {
        setStatus(error && error.message ? error.message : root.dataset.errorMessage);
      });
    }

    const revealRoot = root.closest(".shopify-section") || root;
    const revealJob = {
      options: {
        root: revealRoot,
        selector: ".lucky-draw__reveal",
        visibleClass: "is-visible",
        observedAttr: "data-lucky-draw-observed",
        threshold: 0.08,
        unobserveOnVisible: true,
      },
    };
    if (window.UlanziRevealOnScroll) window.UlanziRevealOnScroll.enqueueInit(revealJob);
    else {
      window.UlanziRevealOnScrollQueue = window.UlanziRevealOnScrollQueue || [];
      window.UlanziRevealOnScrollQueue.push(revealJob);
    }
  }

  function boot() {
    document.querySelectorAll("[data-lucky-draw]").forEach(init);
  }

  selfCheck();
  if (typeof document === "undefined") return;
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-lucky-draw]").forEach(init);
  });
})();
